import { productsApi } from '../api'
import { PaginatedProductList } from '../api-client'

export const fetchProducts = async (
    news: boolean,
    page: number = 1,
    pageSize: number = 8,
): Promise<PaginatedProductList> => {
    try {
        const { data } = await productsApi.productsList({ _new: news ?? false, page, pageSize });
        return data;
    } catch (error) {
        console.error("Error fetching products: ", error);
        throw error;
    }
}
